import React from 'react';
import cn from 'classnames';

interface ChipGroupProps {
	children: React.ReactNode,
	className?: string,
	verticalList?: boolean,
}

const ChipGroup = (props: ChipGroupProps) => {
	const {
		className,
		children,
		verticalList = false,
	} = props;

	return (
		<div
			className={cn(
				'chip-group',
				className,
				{ 'vertical-list': verticalList },
			)}
		>
			{children}
		</div>
	);
};

export default ChipGroup;
